{
  "screen": {
    "heading": "New patient",
    "explanation": "For a patient who is not in the record. The number comes from the ward's pre-printed reservnummer bands — the record does not issue numbers itself.",
    "searchFirst": "Search first. A patient already in the record must not be registered a second time.",
    "noNationalNumber": "A personnummer cannot be entered here. Search for the patient first — a patient with a personnummer is usually already in the record. If you cannot find them, register them with a reservnummer from the band.",
    "irreversible": "A registered patient cannot be removed. Mistakes are corrected by a new version.",
    "requiredHint": "Fields with no note must be filled in.",
    "optional": "optional",
    "admitsTo": "The patient is admitted to ward {ward}.",
    "noWard": "No ward could be loaded. The patient cannot be admitted without a ward.",
    "register": "Register the patient",
    "registering": "Registering …",
    "cancel": "Cancel",
    "close": "Close",
    "discardQuestion": "Close the form? What you have typed will not be saved.",
    "discardConfirm": "Close without registering",
    "discardCancel": "Keep filling it in",
    "registeredOk": "The patient is registered as {identifier} and is in the record.",
    "registeredOnWard": "Admitted to {ward}.",
    "openPatient": "Open the patient overview",
    "registerAnother": "Register another patient"
  },
  "field": {
    "assigner": "Issued by",
    "givenName": "Given name",
    "familyName": "Family name",
    "sex": "Sex",
    "isEstimatedIdentity": "The identity is assumed, not established"
  },
  "fieldHint": {
    "identifier": "Read the number off the band, for example TST00000001. Three letters and eight digits.",
    "ward": "The ward the patient is admitted to. Changing it here changes the ward list too.",
    "assigner": "The unit that owns the number series the band came from.",
    "givenName": "Leave empty if the name is not known.",
    "familyName": "Must be filled in, or mark the identity as assumed below.",
    "birthDate": "YYYY-MM-DD. Leave empty if the birth date is not known.",
    "bed": "Room and bed as staff say them. Leave empty if there is no bed right now, or if the patient is in a corridor — the patient is then listed last on the ward, without a bed.",
    "isEstimatedIdentity": "For a patient who cannot be identified. The record then shows that the name and birth date are an assumption.",
    "identifierDemo": "Test environment: there are no wristbands to read here. Make up a number starting TST8000 and ending in four digits of your own, for example TST80001234. If it is taken the form says so — choose four other digits."
  },
  "sex": {
    "notAnswered": "Not stated"
  },
  "refusal": {
    "identifierMissing": "Fill in the reservnummer from the band.",
    "identifierIsNationalNumber": "That looks like a personnummer, and a personnummer cannot be entered here. Search for the patient instead. If you cannot find them, register them with a reservnummer from the band. The number was not sent.",
    "identifierMalformed": "The reservnummer is not accepted. It must be {letters} letters followed by {digits} digits.",
    "identifierInUse": "{identifier} is already in the record. The patient was not registered again — open the patient instead.",
    "assignerMissing": "Fill in which unit owns the number series.",
    "familyNameMissing": "Fill in a family name, or mark the identity as assumed.",
    "fieldTooLong": "{field} is too long. Shorten it to at most {maximum} characters.",
    "sexUnknown": "The sex is not accepted. Choose one of the options in the list.",
    "birthDateMalformed": "The birth date is not accepted. Write it as YYYY-MM-DD, or leave the field empty.",
    "birthDateInFuture": "The birth date is in the future.",
    "wardMissing": "No ward is selected. The patient was not registered.",
    "wardNotFound": "Ward {ward} is not in the record. The patient was not registered.",
    "roleMayNotDocument": "Your role may not document in the record. The patient was not registered.",
    "unknown": "The patient was not registered. Try again.",
    "unavailable": "No contact with the server. The patient was not registered — leave the form open and try again."
  }
}
